import { Grid } from '@material-ui/core'
import React, { useState } from 'react'
import "./ChangeSystemPopUp.scss";
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import FolderIcon from '@material-ui/icons/Folder';
import VisibilityIcon from '@material-ui/icons/Visibility';

const renderBtnIcon = (iconName) => {
    if (iconName === 'add') {
        return <AddIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'edit') {
        return <EditIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'delete') {
        return <DeleteIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'up') {
        return <ArrowUpwardIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'down') {
        return <ArrowDownwardIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'correct') {
        return <CheckCircleIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'incorrect') {
        return <CancelIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'folder') {
        return <FolderIcon className='icon' style={{ fontSize: '15px' }} />
    } else if (iconName === 'vision') {
        return <VisibilityIcon className='icon' style={{ fontSize: '15px' }} />
    } else {
        return null;
    }
}

// this is the menu options on click on 3 dots in the accordion row
export default function ChangeSystemPopUp(props) {
    const { data, id, handleViewAllDetails, view, onClickHandler, clickHandlers, rowIndex, layer, onItemClick } = props;
    const [showPopUpByLabel, setShowPopUpByLabel] = useState(null);
    const [showPopUp, setShowPopUp] = useState(false);
   
    const handleOpenPopUp = (label) => {
        if (label) {
            setShowPopUpByLabel(label)
            setShowPopUp(true)
        }
        if (label === "Show Details") {
            handleViewAllDetails()
        }
    }

    const handleClick=(label)=>{
        if (label === "Show Details") {
            handleViewAllDetails()
        }
        if (onItemClick) {
            const item = data.find(d => d.label === label);
            if (item && item.icon) {
                onItemClick(item.icon);
            }
        }
    }
  
    return (
        <>
            <Grid className='changeSystemPopUp__main'  >
                {data.map((item, index) => {

                    return <> <Grid key={item.label + id} className='changeSystemPopUp__list__item' style={{ position: 'relative', justifyContent: `${item.icon === undefined ? 'right' : 'left'}` }} 
                    onClick={(e) => {
                        if (onItemClick) {
                            handleClick(item.label);
                        } else {
                            if (item.label in clickHandlers) {
                                if (item.label === 'Move Up' || item.label === 'Move Down'){
                                    clickHandlers[item.label](rowIndex, layer);
                                }else{
                                    clickHandlers[item.label](id, layer);
                                }
                            }
                            if (item.label === 'Show Details'){
                                handleViewAllDetails()
                            }
                            
                        }
                    }}  > 
                        <span className='changeSystemPopUp__list__item__icon' >
                            {renderBtnIcon(item.icon)}
                        </span>
                        &nbsp;
                        &nbsp;
                        <span className='changeSystemPopUp__list__item__text'>{item.label}</span>

                    </Grid>

                    </>
                })}
            </Grid>
        </>
    )
}

// showPopUp && <OpenedFilePopUp /> : item.label === 'Edit File' ? showPopUp && <AddFilePopUp /> : item.label === 'Open File' ? showPopUp && <DeletePopUp /> 